import React from 'react';
import { segmentTrackEvent } from '../utils';
import VideoHero from '../components/Article/ArticleModules/EmbedModule/VideoHero';
import Shop from './Shop';

const handleSubSectionLinkClick = (e) => {
  const { target } = e;
  const targetTagName = target.tagName.toLowerCase();
  let trackableElement = target;
  let innerHTML = '';
  if ((targetTagName === 'a') || ((targetTagName === 'img') && (target.parentNode.tagName.toLowerCase() === 'a')) || this.props.dataEventName) {
    if (targetTagName === 'img') {
      trackableElement = target.parentNode;
      innerHTML = target.src.substring(target.src.lastIndexOf('/') + 1).split('?')[0];
    } else {
      ({ innerHTML } = target);
    }
  }
  const destinationUrl = trackableElement.getAttribute('href');
  const linkType = trackableElement.getAttribute('data-link-type') || 'text-link';
  const articleClickedTracker = {
    destinationUrl,
    module: 'sub-section',
    category: linkType,
    linkType,
    label: `${innerHTML} hyperlink`,
  };
  segmentTrackEvent('article_link_clicked', articleClickedTracker);
};

// const handleTrackVideo = (e) => {
//   // const { title } = this.props;
//   const { target } = e;
//   const targetTagName = target.tagName.toLowerCase();
//   let trackableElement = target;
//   let innerHTML = '';
//   if ((targetTagName === 'a') || ((targetTagName === 'img') && (target.parentNode.tagName.toLowerCase() === 'a'))) {
//     if (targetTagName === 'img') {
//       trackableElement = target.parentNode;
//       innerHTML = target.src.substring(target.src.lastIndexOf('/') + 1).split('?')[0];
//     } else {
//       ({ innerHTML } = target);
//     }
//   }
//   const videoUrl = trackableElement.getAttribute('src');
//   const linkType = 'video';
//   const videoClickedTracker = {
//     videoUrl,
//     module: 'video-embed',
//     hypercontext: innerHTML,
//     category: linkType,
//     label: `${innerHTML} video`,
//   };
//   const clicked = 'video_clicked';
//   segmentTrackEvent(clicked, videoClickedTracker);
// };

const MainRecipe = ({
  subSection,
  isMobile,
  sectionIndex,
}) => {
  const {
    moduleType,
    type,
    title,
    subTitle,
    videoEmbed,
    body,
    recipeButton,
    shopButton,
    shopTitle,
    items,
  } = subSection;

  const getRecipeButtonTracker = {
    destinationUrl: recipeButton.buttonUrl,
    module: 'mainRecipe',
    category: 'data-link-type',
    linkType: 'data-link-type',
    label: `Purewow recipe: ${title}`,
  };

  // const shopButtonTracker = {
  //   destinationUrl: shopButton.buttonUrl,
  //   module: 'mainRecipe',
  //   category: 'open-kroger-product-link',
  //   linkType: 'open-kroger-product-link',
  //   label: `Shop Essentials & More: ${title}`,
  // };

  const videoClickedTracker = {
    module: 'video-embed',
    category: 'video',
    label: `${title} video`,
  };

  const subhedClass = `sub-section-subhed ${type}-hed`;
  const getRecipeBtnClass = `get-recipe-cta ${type}`;
  // const shopCTABtnClass = `shop-cta-button ${type}`;

  return (
    <>
        <div className="sub-section-image-container video"
          // onClick={() => { segmentTrackEvent('video_clicked', videoClickedTracker); }}
        >
            <VideoHero
              embed={videoEmbed}
              title={title}
              isMobile={isMobile}
              // onClick={e => handleTrackVideo(e)}
            />
        </div>
        <div className="sub-section-copy">
          <div className="sub-section-copy-wrapper">
            <h3 className={subhedClass} dangerouslySetInnerHTML={{ __html: title }}></h3>
            <h4 className="sub-section-subtitle" dangerouslySetInnerHTML={{ __html: subTitle }}></h4>
            <p className={`sub-section-copy-body ${type}`}
              dangerouslySetInnerHTML={{ __html: body }}
              onClick={e => handleSubSectionLinkClick(e)}>
            </p>
            <div className="buttons-wrapper">
              <a className={getRecipeBtnClass} href={recipeButton.buttonUrl} target="_blank" onClick={() => { segmentTrackEvent('cta_clicked', getRecipeButtonTracker); }}>{recipeButton.buttonText}</a>
            </div>
          </div>
          {/* <div className="buttons-wrapper">
            <a className={getRecipeBtnClass} href={recipeButton.buttonUrl} target="_blank" onClick={() => { segmentTrackEvent('cta_clicked', getRecipeButtonTracker); }}>{recipeButton.buttonText}</a>
            <div className="shop-cta-wrapper">
              <div className="shop-cta-line"></div>
              <div className={shopCTABtnClass}>
                <a className="shop-cta" href={shopButton.buttonUrl} target="_blank" onClick={() => { segmentTrackEvent('cta_clicked', shopButtonTracker); }}>{shopButton.buttonText}</a>
              </div>
            </div>
          </div> */}
        </div>
        {/* <div className='shop-module'>
          <Shop type={type} items={items} shopTitle={shopTitle} />
        </div> */}
    </>
  );
};

export default MainRecipe;
